<template>
  <div v-if="dialogVisible">
    <el-dialog :title="$t('lang.Button.edit')" :visible.sync="dialogVisible" center>
      <div class="form">
        <el-form label-width="170px">
          <el-form-item :label="`${$t('lang.smartlink.baudRate')}：`">
            <el-select size="small" v-model="comForm.baudrate" clearable class="Form-Input-Width">
              <el-option v-for="(item, index) in BaudRateList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.dataBits')}：`">
            <el-select 
              allow-create 
              filterable  
              default-first-option 
              size="small" 
              v-model="comForm.data_bits" 
              clearable 
              class="Form-Input-Width">
              <el-option v-for="(item, index) in DataBitList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.stopBits')}：`">
            <el-select 
              size="small" 
              filterable  
              allow-create
              default-first-option 
              v-model="comForm.stop_bits" 
              clearable 
              class="Form-Input-Width">
              <el-option v-for="(item, index) in StopBitList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.checkBits')}：`">
            <el-select size="small" v-model="comForm.parity" clearable class="Form-Input-Width">
              <el-option v-for="(item, index) in CheckDigitList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.flowControl')}：`">
            <el-select size="small" v-model="comForm.flow_ctrl" clearable class="Form-Input-Width">
              <el-option v-for="(item, index) in FlowControlList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.enableSubcontracting')}：`">
            <el-checkbox v-model="comForm.enable_frame"></el-checkbox>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.subcontractingInterval')}：`">
            <el-input size="small" v-model="comForm.timeout" clearable class="Form-Input-Width"></el-input>
            <span class="com_Tips">{{$t('lang.smartlink.subcontractingIntervalTips')}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.smartlink.subcontractingLength')}：`">
            <el-input size="small" v-model="comForm.frame_len" clearable class="Form-Input-Width"></el-input>
            <span class="com_Tips">{{$t('lang.smartlink.subcontractingLengthTips')}}</span>
          </el-form-item>
        </el-form>
        
      </div>
       <el-button
        type="danger"
        size="mini"
        class="Config-Buttom"
        @click="updateCom"
      >
        {{$t('lang.ConfigSetting.SaveApply')}}
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { updateConfig } from "@/api/configurationlist";
import { BaudRateList, DataBitList, StopBitList, CheckDigitList, FlowControlList } from '@/utils/com.js'
export default {
  props: ['deviceDid', 'deviceSn'],
  data() {
    return {
      dialogVisible: false,
      index: 0,
      comForm: {
        section:'',
        baudrate: '',
        data_bits: '',
        stop_bits: '',
        parity: '',
        flow_ctrl: '',
        enable_frame: '',
        timeout: '',
        frame_len: ''
      },
      originalCom: {},
      BaudRateList, //波特率选项
      DataBitList, //数据位选项
      StopBitList,  //停止位选项
      CheckDigitList, //校验位选项
      FlowControlList, //流控选项
    }
  },
  methods: {
    show(item, index) {
      this.comForm.section = item.section
      this.comForm.baudrate = item.baudrate
      this.comForm.data_bits = item.data_bits
      this.comForm.stop_bits = item.stop_bits
      this.comForm.parity = item.parity
      this.comForm.flow_ctrl = item.flow_ctrl
      this.comForm.enable_frame = item.enable_frame == '1' ? true : false
      this.comForm.timeout = item.timeout
      this.comForm.frame_len = item.frame_len
      this.index = index
      this.dialogVisible = true
      this.originalCom = cloneDeep(this.comForm)
    },
    updateCom() {
      if(!isEqual(this.originalCom, this.comForm)) {
        let copyData = cloneDeep(this.comForm)
        copyData.enable_frame = copyData.enable_frame == true ? '1' : ''
        updateConfig(this.deviceSn, this.deviceDid,[
          {
            section: copyData.section,
            config: "smartlink",
            action: 0,
            index: [this.index],
            // server: "smartlink",
            options: {
                ...copyData
            },
          },
        
        ]).then(res => {
          if(res.data.data.mess === 0) {
            this.$message.success(this.$t('lang.ConfigSetting.successSetting'))
            this.$emit('updateData')
            this.dialogVisible = false
          }else{
            this.$message.error(this.$t('lang.ConfigSetting.failSetting'))
          }
        })
      }else{
        this.dialogVisible = false
      }
    }
  }
}
</script>
<style scoped>
.form {
  display: flex;
  justify-content: center;
}
.Form-Input-Width {
  width: 5rem;
}
.Config-Buttom {
  display: table;
  margin: 30px auto;
  font-size: 14px;
  overflow: hidden;
}
.com_Tips{
  margin-left: 5px;
  color: grey;
}
</style>